import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  homeController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'authService',
    '$state',
    '$controller',
    '$timeout',
    '$uibModal',
    '$filter',
    'uploadRevisionService',
    'folderService',
    'EAdminFeatures',
    'EAdditionalFieldTypes',
    'treeService',
    'EFeatures',
    'webApiSettings',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      authService,
      $state,
      $controller,
      $timeout,
      uibModal,
      $filter,
      uploadRevision,
      folderService,
      EAdminFeatures,
      EAdditionalFieldTypes,
      treeService,
      EFeature,
      webApiSettings,
      ETreeItemTypes
    ) {
      'use strict';

      function formatDate(dateString) {
        var d = new Date(dateString),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [day, month, year].join('/');
      }

      function canEditFolder() {
        if ($rootScope.user !== undefined) {
          $rootScope.user.adminFeatures.forEach((data) => {
            const verifyPerms =
              data.IdAdminFeature === EAdminFeatures.ManageExpire;
            const manageFolder =
              data.IdAdminFeature === EAdminFeatures.ManageFolders;
            if (verifyPerms) {
              $scope.verifyHasAdminFeature = true;
            } else if (manageFolder) {
              $scope.verifyManageFolder = true;
            } else {
              return false;
            }
          });

          if (
            authService.isAdmin() &&
            $rootScope.folderContextMenu !== undefined &&
            $rootScope.folderContextMenu.IdParent !== undefined
          ) {
            return true;
          } else if (
            $scope.verifyHasAdminFeature ||
            $scope.verifyManageFolder
          ) {
            return (
              $rootScope.folderContextMenu !== undefined &&
              $rootScope.folderContextMenu.IdParent !== undefined &&
              $rootScope.folderContextMenu.HasPermission
            );
          } else {
            return false;
          }
        }
      }

      function canSharedFolder() {
        if (webApiSettings.detailsCompany === 'abase') {
          return false;
        }

        if ($rootScope.user !== undefined) {
          let hasSharedFolderPermission = false;

          $rootScope.user.adminFeatures.forEach((data) => {
            if (data.IdAdminFeature === EAdminFeatures.SharedFolder) {
              hasSharedFolderPermission = true;
            }
          });

          if (
            authService.isAdmin() &&
            $rootScope.folderContextMenu !== undefined &&
            $rootScope.folderContextMenu.IdParent !== undefined
          ) {
            return true;
          } else if (hasSharedFolderPermission) {
            return (
              $rootScope.folderContextMenu !== undefined &&
              $rootScope.folderContextMenu.IdParent !== undefined &&
              $rootScope.folderContextMenu.HasPermission
            );
          } else {
            return false;
          }
        }
      }

      function canDeleteFolder() {
        if ($rootScope.user !== undefined) {
          $rootScope.user.adminFeatures.forEach((data) => {
            const verifyPerms =
              data.IdAdminFeature === EAdminFeatures.ManageExpire;
            const manageFolder =
              data.IdAdminFeature === EAdminFeatures.ManageFolders;

            if (verifyPerms) {
              $scope.verifyHasAdminFeature = true;
            } else if (manageFolder) {
              $scope.verifyManageFolder = true;
            } else {
              return false;
            }
          });

          if (
            authService.isAdmin() &&
            $rootScope.folderContextMenu !== undefined &&
            $rootScope.folderContextMenu.IdParent !== undefined
          ) {
            return true;
          } else if (
            $scope.verifyHasAdminFeature ||
            $scope.verifyManageFolder
          ) {
            return (
              $rootScope.folderContextMenu !== undefined &&
              $rootScope.folderContextMenu.IdParent !== undefined &&
              $rootScope.folderContextMenu.HasPermission
            );
          } else {
            return false;
          }
        }
      }

      function newFile(item) {
        item.revision = new uploadRevision(item);

        if ($rootScope.selectedTreeItem) {
          var canSend = false;
          if (authService.isAdmin()) {
            canSend = true;
          } else {
            if ($rootScope.selectedTreeItem.Features.length > 0) {
              var features = $rootScope.selectedTreeItem.Features;
              canSend = features.includes(EFeature.SEND_DOCUMENT);
            }
          }

          if (canSend) {
            var sendFolder = {};
            sendFolder.Id = $rootScope.selectedTreeItem.Id;
            sendFolder.name = $rootScope.selectedTreeItem.Name;
            sendFolder.TreeItemType = $rootScope.selectedTreeItem.TreeItemType;
            sendFolder.toString = function () {
              return this.name;
            };
            item.revision.folder(sendFolder);
          }
        }
      }

      function encodeImageFileAsURL() {
        var element = document.getElementById('image');
        var file = element.files[0];
        var reader = new FileReader();
        reader.onloadend = function () {
          $scope.imageFile = reader.result;
          var block = $scope.imageFile.split(';');
          var contentType = block[0].split(':')[1];
          var realData = block[1].split(',')[1];
          $scope.base64toBlob(realData, contentType);
        };
        reader.readAsDataURL(file);
      }

      function base64toBlob(b64Data, contentType = '', sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        $scope.imageFileBlob = blob;
      }

      function setRevisionInterval(item, rev) {
        var next = null,
          days = null;
        if (item.revision.NextRevisionDate !== undefined) {
          next = new Date(item.revision.NextRevisionDate.getTime());
          var d = new Date();
          next.setUTCHours(d.getHours());
          next.setUTCMinutes(d.getMinutes());
          if (item.revision.NotificationDays !== 0) {
            days = item.revision.NotificationDays;
          }
        }

        var docType = item.revision.documentType();

        if (
          days === null &&
          docType.NotificationDays !== undefined &&
          docType.NotificationDays !== null
        ) {
          days = docType.NotificationDays;
        }

        if (
          next === null &&
          docType.RevisionInterval !== undefined &&
          docType.RevisionInterval !== null
        ) {
          var interval = docType.RevisionInterval;
          next = new Date(Date.now() + interval * 24 * 60 * 60 * 1000);
        }

        rev.NextRevisionDate = next;
        rev.NotificationDays = days;
      }

      function sendFiles() {
        if (!$rootScope.selectedTreeItem)
          treeService
            .getByIdFolder($scope.idFolder)
            .then((treeItem) => ($rootScope.selectedTreeItem = treeItem));
        if ($scope.modalOpen === true) {
          return;
        }

        $scope.modalOpen = true;

        var uploaderInstance = $scope.uploader;

        var modal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/sendFiles.html',
          controller: 'sendFilesController',
          backdrop: 'static',
          keyboard: true,
          size: 'lg',
          resolve: {
            uploader: function () {
              return uploaderInstance;
            },
            revisionCheckin: function () {
              return undefined;
            },
          },
        });

        modal.result.then(
          function (uploader) {
            $scope.goToMyDocuments();

            uploader.queue.forEach(function (item) {
              item.revision.uploading = true;
            });

            uploader.onBeforeUploadItem = function (item) {
              var authData = authService.authentication;
              var isauth = authData.token !== null && authData.token !== '';
              var keywords = Array.isArray(item.revision.Keywords)
                ? item.revision.Keywords.join(';')
                : null;
              if (item.revision._documentType.IsTitle) {
                var newTitle = '';
                if (!item.revision._documentType.IsTitleAdditional) {
                  newTitle += item.revision._documentType.Name + ' - ';
                }
                item.revision.RevisionAdditionalFields.forEach(
                  function (x, index) {
                    if (x.required === true) {
                      if (index > 0) {
                        newTitle += ' - ';
                      }
                      switch (x.fieldType) {
                        case EAdditionalFieldTypes.Boolean:
                          newTitle += x.value === true ? 'Verdadeiro' : 'Falso';
                          break;
                        case EAdditionalFieldTypes.Date:
                          newTitle += ' ' + formatDate(x.value);
                          break;
                        default:
                          newTitle += x.value;
                          break;
                      }
                    }
                  }
                );

                if (!newTitle === '' || newTitle) {
                  item.revision.Title = newTitle;
                }
              }
              var rev = {
                IdFolder: item.revision.IdFolder,
                IdDocumentType: item.revision.IdDocumentType,
                Title: item.revision.Title,
                Description: item.revision.Description,
                Keywords: keywords,
                Extension: item.revision.Extension,
                Size: item.revision.Size,
                RevisionAdditionalFields: [],
                DocumentDate: item.revision.DocumentDate,
                NextRevisionDate: null,
                NotificationDays: null,
              };

              $scope.setRevisionInterval(item, rev);

              for (
                var i = 0;
                i < item.revision.RevisionAdditionalFields.length;
                i++
              ) {
                var a = item.revision.RevisionAdditionalFields[i];

                // Case DateTime remove offset
                if (
                  a.value !== undefined &&
                  a.value !== null &&
                  a.fieldType === 6
                ) {
                  rev.RevisionAdditionalFields.push({
                    IdAdditionalField: a.id,
                    Value: new Date(a.value.getTime()),
                  });
                } else if (a.value !== undefined && a.value !== null) {
                  rev.RevisionAdditionalFields.push({
                    IdAdditionalField: a.id,
                    Value: a.value,
                  });
                }
              }

              item.formData = [
                {
                  revision: angular.toJson(rev),
                },
              ];

              if (item.revision.IdWorkflow) {
                item.formData.push({
                  workflow: item.revision.IdWorkflow,
                });
              }

              item.headers = {
                Authorization: isauth ? 'Bearer ' + authData.token : '',
              };
            };

            uploader.onSuccessItem = function (item, response) {
              item.revision.id = response.Id;
              item.revision.extension = response.Extension;
              item.revision.isSigned = response.IsSigned;
              item.revision.uploading = true;
            };

            uploader.onCompleteAll = function () {
              var toD4Sign = uploader.queue.filter(function (f) {
                return f.revision.id !== 0 && f.signDocumentD4s === true;
              });

              var toSign = uploader.queue.filter(function (f) {
                return (
                  f.revision.id !== 0 &&
                  f.signDocument === true &&
                  f.signing !== true
                );
              });

              if (toD4Sign.length > 0) {
                var revisions = [];
                revisions.push(toD4Sign[0].revision);

                var error = uploader.queue.filter(function (e) {
                  return e.isError;
                });

                if (error.length === 0) {
                  uploader.clearQueue();
                  $rootScope.$broadcast('toogleSidebar', false);
                }

                uibModal.open({
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modules/signing/signDocumentD4s.html',
                  controller: 'signDocumentsD4sController',
                  resolve: {
                    revisions: () => revisions,
                  },
                });
              }

              if (toSign.length > 0) {
                var revisions = [];

                for (var i = 0, len = toSign.length; i < len; i++) {
                  toSign[i].signing = true;
                  revisions.push(toSign[i].revision);
                }

                var signModal = uibModal.open({
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl:
                    '/views/modules/signing/signDocumentPartial.html',
                  controller: 'signDocumentsController',
                  windowClass: 'sign-modal-window',
                  resolve: {
                    revisions: function () {
                      return revisions;
                    },
                    sealData: function () {
                      return "";
                    },
                  },
                });

                signModal.result.then(function () {
                  var error = uploader.queue.filter(function (e) {
                    return e.isError;
                  });
                  if (error.length === 0) {
                    var allContainsFlow = uploader.queue.every(function (s) {
                      return s.revision.IdWorkflow ? true : false;
                    });
                    var anyInCurrentFolder = uploader.queue.some(function (s) {
                      return s.revision.IdFolder + '' === $state.params.id;
                    });
                    if (!allContainsFlow && anyInCurrentFolder) {
                      $state.reload();
                    }
                    uploader.clearQueue();
                    $rootScope.$broadcast('toogleSidebar', false);
                  }
                });
              } else {
                var error = uploader.queue.filter(function (e) {
                  return e.isError;
                });
                if (error.length === 0) {
                  var allContainsFlow = uploader.queue.every(function (s) {
                    return s.revision.IdWorkflow ? true : false;
                  });
                  var anyInCurrentFolder = uploader.queue.some(function (s) {
                    return s.revision.IdFolder + '' === $state.params.id;
                  });
                  if (!allContainsFlow && anyInCurrentFolder) {
                    $state.reload();
                  }
                  uploader.clearQueue();
                  $rootScope.$broadcast('toogleSidebar', false);
                }
              }
              $state.reload();
            };

            uploader.uploadAll();

            $scope.modalOpen = false;

            $timeout(function () {
              $rootScope.$broadcast('toogleSidebar', true);
            }, 500);
          },
          function () {
            var filter = $scope.uploader.queue.filter(function (item) {
              return item.isUploading === false;
            });

            filter.forEach(function (item) {
              $scope.uploader.removeFromQueue(item);
            });

            $scope.modalOpen = false;
          }
        );
      }

      function newFolder() {
        if ($scope.modalOpen === true) {
          return;
        }

        var parent = $rootScope.folderContextMenu;
        $scope.modalOpen = true;

        $rootScope.editFolderModal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/newFolder.html',
          controller: 'folderController',
          backdrop: 'static',
          keyboard: true,
          size: 'xs',
          resolve: {
            treeFolder: function () {
              return parent;
            },
            isEdit: function () {
              return false;
            },
            isOnlyCreateFolder: function () {
              return true;
            },
          },
        });

        $rootScope.editFolderModal.result.then(
          function (folder) {
            //adicionar a nova pasta na tree e expandir o nó
            $scope.modalOpen = false;
            $rootScope.$broadcast('setFolder', folder);
            $state.reload();
          },
          function () {
            $scope.modalOpen = false;
          }
        );
      }

      function editFolder() {
        if ($scope.modalOpen === true) {
          return;
        }

        var parent = $rootScope.folderContextMenu;
        $scope.editModalOpen = true;

        $rootScope.editFolderModal = uibModal.open({
          scope: $scope,
          rootScope: $rootScope,
          animation: true,
          templateUrl: '/views/partials/newFolder.html',
          controller: 'folderController',
          backdrop: 'static',
          keyboard: true,
          size: 'xs',
          resolve: {
            treeFolder: function () {
              return parent;
            },
            isEdit: function () {
              return true;
            },
          },
        });

        $rootScope.editFolderModal.result.then(
          function (folder) {
            $scope.modalOpen = false;

            if (folder !== undefined) {
              $rootScope.folderContextMenu.removed = true;

              if (folder.idParent !== $rootScope.folderContextMenu.IdParent) {
                var oldPath = folder.path;
                folder.path = folder.parent.path + '/' + folder.id;
                $rootScope.$broadcast('updateOldParent', oldPath);
              }

              $rootScope.$broadcast('setFolder', folder);
              $state.reload();
            }
          },
          function () {
            $scope.modalOpen = false;
          }
        );
      }

      function sharedFolder() {
        if ($scope.modalOpen === true) {
          return;
        }

        var parent = $rootScope.folderContextMenu;
        $scope.editModalOpen = true;

        $rootScope.sharedFolderModal = uibModal.open({
          scope: $scope,
          rootScope: $rootScope,
          animation: true,
          templateUrl: '/views/partials/sharedFolder.html',
          controller: 'publicFolderLinkController',
          backdrop: 'static',
          keyboard: true,
          size: 'xs',
          resolve: {
            treeFolder: function () {
              return parent;
            },
            isEdit: function () {
              return true;
            },
          },
        });
      }

      function cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function deleteModel() {
        return new Promise(function (resolve) {
          folderService.delete($scope.folder).then(
            function () {
              $scope.folder.removed = true;
              $scope.folder.HasChildrens = function () {
                var notRemoved =
                  $scope.folder.Children &&
                  $scope.folder.Children.filter(function (item) {
                    return (
                      !item.removed &&
                      !(item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE || item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
                    );
                  });
                if (
                  $scope.folder.HasChildren &&
                  ($scope.folder.Children === null || notRemoved.length > 0)
                ) {
                  return true;
                } else {
                  return false;
                }
              };
              $rootScope.$broadcast('loadFolder', $scope.folder.IdParent);
              $scope.modalRemoveDocument.close();
            },
            function (error) {
              $scope.questionFolder = true;
              // Se tiver arquivos na pasta vai exibir a mensagem de erro
              if (error.statusCode && error.statusCode === 409) {
                $scope.messageTitle =
                  $filter('translate')('FILES IN TRASH CAN');
                $scope.messageDescription = $filter('translate')(
                  'DELETE FILES TRASH CAN'
                );
                $scope.messageCancel = 'NÃO';
                $scope.modalQuestion = uibModal.open({
                  scope: $scope,
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modal/questionModal/questionModal.html',
                  controller: 'questionModalController',
                  size: 'small',
                  windowClass: 'modal-remove',
                  resolve: {},
                });
              } else if (error.statusCode && error.statusCode === 410) {
                $scope.modalRemoveDocument.close();
                $scope.messageTitle = $filter('translate')('DELETE FAILURE');
                $scope.messageDescription =
                  $filter('translate')('NOT EMPTY FOLDER');

                $scope.modalErrorFolder = uibModal.open({
                  scope: $scope,
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modal/errorModal/errorFolderModal.html',
                  size: 'small',
                  windowClass: 'modal-remove',
                  resolve: {},
                });

                setTimeout(() => {
                  $scope.modalErrorFolder.close();
                }, 3500);
              } else {
                swal.fire({
                  title: error.title,
                  text: error.text,
                });
                $scope.modalRemoveDocument.close();
              }
            }
          );
          resolve();
        });
      }

      function cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function deleteFolder() {
        $scope.folder = $rootScope.folderContextMenu;
        $scope.messageTitle = $filter('translate')('CONFIRM REMOVE');
        $scope.messageDescription = 'Essa operação não pode ser revertida.';
        $scope.messageForward = $filter('translate')('REMOVE');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalRemoveDocument = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'homeController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {},
        });
      }

      function setFolderContextMenu(event, data) {
        if (event.which === 3) {
          $rootScope.folderContextMenu = data;
        }
      }

      function canManageFolder() {
        return (
          authService.isAdmin() ||
          authService.verifyHasAdminFeature([EAdminFeatures.ManageFolders])
        );
      }

      function canCreateFolder() {
        return (
          authService.isAdmin() ||
          authService.verifyHasAdminFeature([EAdminFeatures.OnlyCreateFolder])
        );
      }

      function canDocusign() {
        var comp = authService.getLoggedCompany();
        if (comp !== null) {
          if (comp.length === 0 /*|| comp.length > 1*/) {
            return false;
          } else {
            return comp.Company.CanDocusign;
          }
        } else {
          return false;
        }
      }

      function canD4SignInsertCredential() {
        var comp = authService.getLoggedCompany();
        if ($rootScope.user !== undefined) {
          if (
            $rootScope.user.adminFeatures &&
            comp !== undefined &&
            comp !== null &&
            comp.Company.CanD4Sign
          ) {
            var canD4sign = $rootScope.user.adminFeatures.some((af) => {
              if (af.IdAdminFeature === EAdminFeatures.CanD4SignIntegrate) {
                return true;
              }
            });

            var tokenApi = $rootScope.user.D4SignTokenApi;

            if (canD4sign && (tokenApi === undefined || tokenApi === null)) {
              return true;
            }
          }
        }
        return false;
      }

      function canCertificataInsertCredential() {
        var comp = authService.getLoggedCompany();

        if ($rootScope.user !== undefined) {
          if (
            $rootScope.user.adminFeatures &&
            comp !== undefined &&
            comp !== null &&
            comp.Company.CanCertificata
          ) {
            var canCertificata = $rootScope.user.adminFeatures.some((af) => {
              if (
                af.IdAdminFeature === EAdminFeatures.CanCertificataIntegrate
              ) {
                return true;
              }
            });

            var tokenApi = $rootScope.user.certificataTokenApi;

            if (
              canCertificata &&
              (tokenApi === undefined || tokenApi === null)
            ) {
              return true;
            }
          }
        }
        return false;
      }

      function sendCertificataCredentials() {
        $scope.modal = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl:
            '/views/modules/certificata/signCertificataSettings.html',
          controller: 'signCertificataController',
          keyboard: false,
          resolve: {
            revisions: function () {
              return null;
            },
            docs: function () {
              return null;
            },
          },
        });

        $scope.modal.result.then(function () {
          $scope.modal.close();
        });
      }

      function sendD4SignCredentials() {
        $scope.modal = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modules/signing/signD4sSettings.html',
          controller: 'signDocumentsD4sController',
          keyboard: false,
          resolve: {
            revisions: function () {
              return null;
            },
          },
        });

        $scope.modal.result.then(function () {
          $scope.modal.close();
        });
      }

      function pickFolderDocuSign() {
        $scope.pickFolderValidation = false;
        var modal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/pickFolderDocuSign.html',
          controller: 'pickFolderController',
          backdrop: 'static',
          keyboard: true,
          size: 'sm',
          resolve: {
            treeSendFiles: function () {
              return false;
            },
            canSelectRepository: function () {
              return true;
            },
            idFolderNotShow: function () {
              return undefined;
            },
          },
        });

        modal.result.then(
          function (folder) {
            $scope.folder(folder);
          },
          function () {}
        );
      }

      function closeOptions() {
        $rootScope.displayOptions = false;
      }

      function run() {
        try {
          $controller('baseHomeController', {
            $scope: $scope,
          });

          if ($rootScope.canShowChat === undefined) {
            $rootScope.canShowChat = false;
            $rootScope.chatbotLoaded = false;
            $rootScope.chatbotLoading = false;
          }

          $scope.userDoubt = null;
          $scope.sendImage = false;
          $scope.imageFile = null;
          $scope.imageFileBlob = null;
          $scope.verifyHasAdminFeature = false;
          $scope.verifyManageFolder = false;
          $scope.verifySharedFolder = false;
          $scope.uploader.onAfterAddingFile = $scope.newFile;
          $scope.uploader.onAfterAddingAll = $scope.sendFiles;

          $scope.canEditFolder = logWrapper(
            canEditFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSharedFolder = logWrapper(
            canSharedFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDeleteFolder = logWrapper(
            canDeleteFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newFile = logWrapper(
            newFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.encodeImageFileAsURL = logWrapper(
            encodeImageFileAsURL,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.base64toBlob = logWrapper(
            base64toBlob,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setRevisionInterval = logWrapper(
            setRevisionInterval,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendFiles = logWrapper(
            sendFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newFolder = logWrapper(
            newFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.editFolder = logWrapper(
            editFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sharedFolder = logWrapper(
            sharedFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteFolder = logWrapper(
            deleteFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setFolderContextMenu = logWrapper(
            setFolderContextMenu,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canManageFolder = logWrapper(
            canManageFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCreateFolder = logWrapper(
            canCreateFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDocusign = logWrapper(
            canDocusign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canD4SignInsertCredential = logWrapper(
            canD4SignInsertCredential,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCertificataInsertCredential = logWrapper(
            canCertificataInsertCredential,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendCertificataCredentials = logWrapper(
            sendCertificataCredentials,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendD4SignCredentials = logWrapper(
            sendD4SignCredentials,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.pickFolderDocuSign = logWrapper(
            pickFolderDocuSign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeOptions = logWrapper(
            closeOptions,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
